import React from 'react';
import PaymentContainer from '../../containers/paymentmng/PaymentContainer';

const PaymentViewPage = () => {
  return <PaymentContainer />
};

export default PaymentViewPage;
